import React, { createContext, useState, useEffect } from "react";
import { http } from "../axios/axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      http
        .get("/auth/verify-token")
        .then((res) => {
          setUser(res.data.user);
        })
        .catch((err) => {
          console.error("Auth Check Failed:", err);
          localStorage.removeItem("authToken");
          setUser(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = (userData, token) => {
    localStorage.setItem("authToken", token);
    http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    delete http.defaults.headers.common["Authorization"];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading ? (
        children
      ) : (
        <div className="h-screen w-full flex items-center justify-center bg-[#0a0f1a]">
          <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 border-4 border-blue-600/20 border-t-blue-600 rounded-full animate-spin" />
            <span className="text-[10px] font-black text-blue-500 uppercase tracking-[0.3em] animate-pulse">
              Establishing Secure Link...
            </span>
          </div>
        </div>
      )}
    </AuthContext.Provider>
  );
};
